import { SplitterDataProvider } from '../types';

const fallback = () => {
  console.error('Incorrect Splitter data provider.');
  return Promise.reject();
};

const dp: SplitterDataProvider = {
  getSize: fallback,
  setSize: fallback,
};

export const getSplitterDataProvider = (): SplitterDataProvider => {
  return dp;
};
